export default "__VITE_PUBLIC_ASSET__65eaf152__"